export const DASHBOARD_URL = 'https://dashboard.lendingmitra.com';
